'use strict';

/**
 * HTML loader tab component extends dynamic tab container interface
 */

var HPEServices = require('../../base/hpe.services');
var HPEConstants = require('../../base/hpe.constants');
var DynamicTabContainerInterface = require('../dynamictabcontainer/hpe.dynamic.tab.container.interface');
var HTMLLoaderTabView = require('./hpe.html.loader.tab.view');
var HTMLLoaderTabModel = require('./hpe.html.loader.tab.model');

module.exports = DynamicTabContainerInterface.extend({

    props: {
        view: 'object',
        model: 'object',
        xhr: 'object',
        el: 'object',
        queryClassName: 'string'
    },

    /**
     * initialization called by ampersand
     */
    initialize: function() {
        var that = this;

        //create base model + view
        this.model = new HTMLLoaderTabModel();
        this.view = new HTMLLoaderTabView({
            model: that.model
        });
    },

    /**
     * component initialization called only once (after Ampersand initialize())
     * extend to perform aditional initialization
     * always return this
     * @param {object} options configuration options
     *   must include "el" {object} value as required DOM element reference to attach view to
     *   may include "queryClassName" {string} value as to be used as CSS selector for container element
     *   may include "servicePath" {string} value to be used as model url
     */
    init: function(options) {

        //save classname used to select default 'el' for this component
        this.queryClassName = (options && options.queryClassName) ? options.queryClassName : 'htmlLoaderTab';

        //do not proceed if missing required el param
        if (options && (options.el)) {

            //save reference to passed element
            this.el = options.el;

            //optionally passed service path from tab container component overrides any other model url values
            if (options.servicePath) {
                this.model.url = options.servicePath;

            //update service path if present (if this is the default component rendered by AEM)
            } else if (this.el.getAttribute('data-service-path')) {
                this.model.url = this.el.getAttribute('data-service-path');
            }

            //render on init()
            this.render(this.el);

            //required response in case this is the default AEM rendered component on page load
            HPEServices.publish(HPEConstants.dynamictabcontainer.CHILDINIT, {
                child: this,
                htmlTabInstance: true
            });
            return this;
        }
    },

    /**
     * destroy the view
     * extend to perform additional cleanup, remove events, abort XHR, etc
     */
    destroyView: function() {

        this.view.remove();

        //attempt to stop any XHR not currently complete
        if (this.xhr && this.xhr.readyState && (this.xhr.readyState < 4)) {
            this.xhr.abort();
        }
        this.xhr = null;

    },

    /**
     * render the view
     * extend to add additional view initialization, etc
     * @param  {object} el required DOM element reference to attach view to
     */
    render: function(el) {

        //determine if the current view is the default AEM rendered view or a client-side initialized view
        //based on the passed element classname
        var isDefaultAEMRender = el.classList.contains(this.queryClassName);

        //if not the default AEM rendered view on page load, use the passed element to render view
        if (!isDefaultAEMRender) {
            this.view.el = el;
        }

        //check if data was fetched already
        //but do not prompt render() if current view is default AEM rendered view
        if (!isDefaultAEMRender) {

            if ( this.model.content === '' ) {

                // request data and save reference to returned xhr, rendering the view on success
                HPEServices.publish(HPEConstants.dynamictabcontainer.LOADER_SHOW);
                this.xhr = this.model.fetch({
                    success: function (model, response, options) {
                        options.ctrl.view.render();
                        HPEServices.publish(HPEConstants.dynamictabcontainer.LOADER_HIDE);
                    },
                    ctrl: this
                } );

            // if data fetched already, just render the view
            } else {
                this.view.render();
            }
        }
        // if this is default AEM rendered view, copy markup from DOM to model, to avoid fetching tab content via service when user clicks on this tab again
        else {
            this.model.content = '<div class="' + this.queryClassName + '">' + el.innerHTML + '</div>';
        }
    }
});
